/* istanbul ignore file */
import { Config, FileRequest, FileResponse, FileShape, FilesRequest, FilesResponse } from '../types'
import { MpxItemResponse, MpxResponseBase } from '../types/MpxTypes'
import { generatePath } from '../utils'
import { getMpAgent } from './utils'

const mpAgent = getMpAgent()

const PATHS = {
  FILES: '/files',
  FILE: '/files/:fileId',
  DOWNLOAD: '/files/download/:fileId',
}

export interface FileDetails extends Omit<FileRequest, 'file'> {
  file: any
}

export class FilesApi {
  static createFile(fileDetails: FileDetails) {
    const formData = new FormData()

    formData.append('file', fileDetails.file)
    fileDetails.name && formData.append('name', fileDetails.name)
    fileDetails.fileType && formData.append('fileType', fileDetails.fileType)
    fileDetails.ownerId && formData.append('ownerId', `${fileDetails.ownerId}`)

    return mpAgent
      .post<FileResponse>(PATHS.FILES, formData)
      .then(response => response && response.data.item)
  }

  static getFiles(requestParams?: FilesRequest) {
    return mpAgent
      .get<FilesResponse>(PATHS.FILES, { params: requestParams })
      .then(response => response && response.data.items)
  }

  static getFile(fileId: string) {
    return mpAgent.get<MpxItemResponse<FileShape[]>>(generatePath(PATHS.FILE, { fileId }))
  }

  static getFileUrl(fileId: string) {
    const baseUrl = Config.get('MP_BASE_URL')

    // replace trailing slash if it exists to avoid double slashes in the URL
    return `${baseUrl.replace(/\/$/, '')}${generatePath(PATHS.DOWNLOAD, { fileId })}`
  }

  static downloadFile(fileId: string, options?: any) {
    return mpAgent.get(generatePath(PATHS.DOWNLOAD, { fileId }), {
      responseType: 'blob',
      ...options,
    })
  }

  static deleteFile(fileId: string) {
    return mpAgent.delete<MpxResponseBase>(generatePath(PATHS.FILE, { fileId }))
  }
}
